import {useUrl} from '@shopify/hydrogen';

import {brands} from '~/consts/brands';

export const useSubdomainBrand = () => {
  const {host} = useUrl();

  // NOTE: returns null if no subdomain - this can cause odd behavior locally,
  // but in a hosted environment, there will not even be any sort of content loaded
  // or delivered if accessing a subdomain that is not set up; likely a non-issue
  return brands.find((b) => host.startsWith(b.subdomain)) ?? null;
};
